import './assets/css/App.css';
import './assets/css/Modeling.css';
import './assets/css/Projects.css';
import './assets/css/Publications.css';
import './assets/css/Contact.css';
import NavBar from './components/NavBar.tsx';
import About from './components/About.tsx';
import Projects from './components/Projects.tsx';
import Publications from './components/Publications.tsx';
import Modeling from './components/3dModeling.tsx';
import Contact from './components/Contact.tsx';

function App() {
  return (
    <div className='App'>
      <NavBar />
      <About />
      <Projects />
      <Publications />
      <Modeling />
      <Contact />

      <footer className="footer">
        <p>© {new Date().getFullYear()} Bianca-Ștefana Popa. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
